import { PARTITION } from './constants';
import type { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];
const selectContext = (state: any) => selectPartition(state) && selectPartition(state).context;
const selectIntentId = (state: any) => selectPartition(state) && selectPartition(state).intentId;
const selectCheckOutId = (state: any) => selectPartition(state) && selectPartition(state).checkOutId;

export default {
  selectPartition,
  selectContext,
  selectIntentId,
  selectCheckOutId,
};
